var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.87,
    height: 33.81,
    viewBox: "0 0 42.87 33.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e2e2e2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-85.541 -834)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M85.541,867.81V853.833q0-18.4,18.333-19.833l1.548,6.233Q94.468,842.27,95.3,851.381h6.071V867.81Zm22.989,0V853.833q0-18.4,18.333-19.833l1.548,6.233q-10.954,2.037-10.239,11.148h6.191V867.81Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.737509cc77f2e43d90b2c43154b99c5f.svg";
export { ForwardRef as ReactComponent };